import { QueryClient } from '@tanstack/react-query';
import { ehTimeout, statusDe } from './erroDaApi';

/**
 * Camada de dados. Antes cada tela fazia `axios` dentro de `useEffect`, sem cache, sem dedupe,
 * sem cancelamento — e algumas com quatro efeitos disparando o mesmo carregamento, onde vencia a
 * resposta que chegasse por último (a tela de Contatos fazia exatamente isso).
 *
 * Padrões escolhidos para este produto:
 *  - `staleTime` de 30s: o operador troca de tela o tempo todo; voltar não precisa refazer tudo.
 *  - sem refetch ao focar a janela: a atualização em tempo real vem do WebSocket, não de polling.
 *  - NOVA TENTATIVA SÓ ONDE ELA PODE AJUDAR (M-B B1, 28/09): 1× em 5xx (o servidor pode ter tropeçado);
 *    nunca em timeout (15 s já foram esperados), nunca em 4xx (repetir não muda a recusa), nunca sem
 *    resposta (rede caída: a mensagem honesta vem já). Antes: `retry: 1` em tudo.
 */
export const politicaDeRetry = (falhas: number, erro: unknown): boolean =>
  falhas < 1 && statusDe(erro) >= 500 && !ehTimeout(erro);

/** A ÚNICA fábrica de QueryClient. O App e os testes usam esta; o teste só mexe no relógio. */
export function criarQueryClient(relogio: { retryDelay?: number; gcTime?: number } = {}): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: relogio.gcTime ?? 5 * 60_000,
        refetchOnWindowFocus: false,
        retry: politicaDeRetry,
        ...(relogio.retryDelay !== undefined ? { retryDelay: relogio.retryDelay } : {}),
      },
      mutations: { retry: 0 },
    },
  });
}

export const queryClient = criarQueryClient();   // App.js:13 importa este nome
